import styles from "./leasecard.module.css";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { useHistory } from "react-router-dom";

const LeaseCard = ({ item }) => {
    const redirect = useHistory();

    return (<Link key={item?.id} className={`${styles.ProspectCard}`} to={"/leases/details/" + item.tenant_id} >
        <div className={`${styles.ProspectCardUnder}`}>
            <div className={`${styles.ProspectCardHeadSection}`}>
                <div className={`${styles.ProsIMGSec}`}>
                    {item?.tenant_image !== "" ? <img src={item?.tenant_image} className={`${styles.ProspectCardImg}`} alt="" /> : <p>{item?.tenant_initial}</p>}
                </div>

                <div className={`${styles.HeadConSec}`}>
                    <div className={`${styles.prospectNameActionSec}`}>
                        <p className={`${styles.ProsUserName} ${styles.CallLink}`}>{item.tenant_name} {item?.no_of_tenant > 1 && '+' + (item?.no_of_tenant - 1)}</p>
                    </div>
                    <p className={`${styles.ProsUserName}`}>
                        {item.lease_status.indexOf(1) > -1 && item.lease_status.indexOf(6) === -1 && (<span className={`${styles.TagDiv} ${styles.Success}`}>Verified</span>)}
                        {item.lease_status.indexOf(0) > -1 && item.lease_status.indexOf(6) === -1 && (<span className={`${styles.TagDiv} ${styles.Purple}`}>Not Verified</span>)}
                        {item.lease_status.indexOf(4) > -1 && item.lease_status.indexOf(6) === -1 && (<span className={`${styles.TagDiv} ${styles.Success}`}>Signed</span>)}
                        {item.lease_status.indexOf(3) > -1 && item.lease_status.indexOf(6) === -1 && (<span className={`${styles.TagDiv} ${styles.Success}`}>Tenant Signed</span>)}
                        {item.lease_status.indexOf(2) > -1 && item.lease_status.indexOf(6) === -1 && (<span className={`${styles.TagDiv} ${styles.Purple}`}>Not Signed</span>)}
                        {item.lease_status.indexOf(5) > -1 && (<span className={`${styles.TagDiv} ${styles.Yellow}`}>Expire Soon</span>)}
                        {item.lease_status.indexOf(6) > -1 && (<span className={`${styles.TagDiv} ${styles.Error}`}>Expired</span>)}
                        {item.lease_status.indexOf(7) > -1 && (<span className={`${styles.TagDiv} ${styles.Archive}`}>Archived</span>)}
                    </p>
                </div>
            </div>
            <div className={`${styles.ProspectCardBodySec}`}>
                <ul>
                    <li>
                        <p className={`${styles.Title}`}><img src="/static/img/bill-icon.svg" alt="" />Rent :</p>
                        <p className={`${styles.Content}`}>${item.formatted_rent}</p>
                    </li>
                    <li>
                        <p className={`${styles.Title}`}><img src="/static/img/credit-icon.svg" alt="" />Sec. Deposit :</p>
                        <p className={`${styles.Content}`}>${item.formatted_amount}</p>
                    </li>
                    <li>
                        <p className={`${styles.Title}`}><img src="/static/img/calendar.svg" alt="" />Lease Term :</p>
                        <p className={`${styles.Content}`}>{dayjs(item.start_date).format("L")} - {dayjs(item.end_date).format("L")}</p>
                    </li>
                    <li>
                        <p className={`${styles.Title}`}><img src="/static/img/home.svg" alt="" />Property :</p>
                        <p className={`${styles.Content} ${styles.Hover}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push('/properties/details/' + item?.property_id); }}>{item.property_name}</p>
                    </li>
                    <li>
                        <p className={`${styles.Title}`}><img src="/static/img/rooms.svg" alt="" />Unit :</p>
                        <p className={`${styles.Content}`}>{item.apt_no}</p>
                    </li>
                </ul>
            </div>
        </div>
    </Link>)
}

export default LeaseCard;